export class TireMasterModel {

    // 前タイヤのサイズのリスト
    frontTireSizeList: Array<any> = [];

    // 後タイヤのサイズのリスト
    reaTireSizeList: Array<any> = [];

    /** 選択情報をリセットします */
    public reset() {
        // 前タイヤのサイズのリスト
        this.frontTireSizeList = [];
        // 後タイヤのサイズのリスト
        this.reaTireSizeList = [];
    }
}